var _path, _path2, _circle;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconMarkers(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.532 16.5528C12.4111 16.4507 12.27 16.3298 12.1125 16.1918C11.5699 15.7165 10.8371 15.0422 10.0753 14.2465C8.52106 12.6231 6.96241 10.6114 6.51505 8.80368L6.51102 8.78739L6.50626 8.77129C6.25231 7.91199 6.1861 7.00814 6.31212 6.121C6.43813 5.23387 6.75342 4.3842 7.23662 3.62961C7.71981 2.87502 8.35961 2.23315 9.11263 1.74752C9.86566 1.26189 10.7143 0.943845 11.601 0.814962C12.4877 0.686078 13.3918 0.749364 14.2519 1.00053C15.112 1.2517 15.9081 1.68487 16.5861 2.27068C17.2641 2.85649 17.8083 3.58123 18.1816 4.39578C18.5549 5.21013 18.7487 6.09519 18.75 6.99099C18.75 7.36644 18.7153 7.73611 18.6504 8.09346L18.5189 8.81831L18.544 8.82332C18.3661 9.52991 18.0132 10.2864 17.5332 11.0605C16.9051 12.0733 16.0922 13.0644 15.2761 13.9425C14.462 14.8186 13.6575 15.5688 13.0556 16.1004C12.8559 16.2768 12.6789 16.4288 12.532 16.5528ZM12.995 16.9335C12.9949 16.9335 12.995 16.9335 12.995 16.9335L12.995 16.9335Z",
    stroke: "#6E6E6E",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.43553 1C5.61766 1.12408 4.83491 1.43026 4.14036 1.89778C3.44581 2.36531 2.85569 2.98325 2.41001 3.7097C1.96433 4.43615 1.67352 5.25414 1.55729 6.10819C1.44106 6.96224 1.50213 7.8324 1.73636 8.65965C2.55781 12.1242 7.29097 16 7.29097 16L8.5 14.6905",
    stroke: "#6E6E6E",
    strokeWidth: 1.5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 6,
    r: 2.25,
    stroke: "#6E6E6E",
    strokeWidth: 1.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMarkers);
export default __webpack_public_path__ + "static/media/icon_markers.50d4ba11ba07c702d42e71f5312a29e6.svg";
export { ForwardRef as ReactComponent };